import { render, staticRenderFns } from "./OurDataContainer.vue?vue&type=template&id=674b5c91&"
import script from "./OurDataContainer.vue?vue&type=script&lang=js&"
export * from "./OurDataContainer.vue?vue&type=script&lang=js&"
import style0 from "./OurDataContainer.vue?vue&type=style&index=0&id=674b5c91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports